import React, { useState } from 'react'
import Button from '../SelectValue/Button'
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import CancelIcon from '@mui/icons-material/Cancel';
import Loading from '../SelectValue/Loading';
import Inputtt from '../SelectValue/Inputtt';
import postService from '../../Services/post-service';
import swal from 'sweetalert';
import TexttArea from '../SelectValue/TexttArea';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'white',
  boxShadow: 24,
};

export default function CreateAssestCategory({ open, handleClose }) {
  const [loading, setLoading] = useState(false)
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  
  const onSubmit = (e) => {
    e.preventDefault()
    setLoading(true)
    
    postService.createAssestCategory({
      "name": name,
      "slug": name.toLowerCase().replace(/\s+/g, '-'),
      "description": description
    }).then(
      (response) => {
        console.log(response.data)
        setLoading(false)
        if (response.data.status === '2000') {
          swal(response.data.description).then(() => {
            window.location.reload()
          })
        } else {
          swal(response.data.description)
        }

        if (response.data.status >= 4000) {
          swal(response.data.description)
          console.log('my response ', response)
        }
      },
      (error) => {
        setLoading(false)
        console.log(error)
        swal("Something went wrong, try again")
      }
    )
  }

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={style} className='relative rounded-lg p-6 pt-10'> 
            <Loading open={loading} variant="local" />
            <div className='h-[60vh] md:mt-5'>
              <div className='mt-6 flex justify-end mb-3'>
                <div>
                  <CancelIcon onClick={handleClose} className='text-back-color2 cursor-pointer text-[38px]' fontSize="large"/>
                </div>
              </div>
              <div>
                <div className=''>
                  <div className='mt-10'>
                    <p className='mb-3 text-back-color2'>Create Asset Category</p>
                    <div className='mt-5'>
                      <div>
                        <form onSubmit={onSubmit}> 
                          <div className='w-full flex mb-2 justify-center'>
                            <Inputtt
                              label='Name'
                              value={name}
                              onChange={setName}
                            />
                          </div>
                          
                          <div className='w-full flex mb-2 justify-center'>
                            <TexttArea
                              label='Description'
                              value={description}
                              onChange={setDescription}
                            />
                          </div>
                          
                          <div className='grid grid-cols-1 mb-5 mt-6'>
                            <Button name='Create' />
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
